import ConfigBuilder from "./ConfigBuilder";
import Events from "./Events";
import Dialog from '../dialog';

export default class Triggers extends EventTarget
{
    constructor()
    {
        super();
        this.bind();
    }

    bind()
    {
        Events.delegate(
            document,
            'click',
            'button[type=submit][data-dialog]',
            (e) => {
                e.stopImmediatePropagation();
                e.preventDefault();

                let target = e.closest;
                let form = target.closest('form');
                let self = this;
                let configBuilder = new ConfigBuilder(target);
                configBuilder.callback = function(callbackEvent) {
                    self.onOpen(this, e, callbackEvent);
                };

                let config = configBuilder.config;
                // Need to add the method from the form
                config.method = form.getAttribute('method').toUpperCase();

                let action = form.getAttribute('action');

                let formData = new FormData(form);

                // FormData does not include the value from the submit button by default
                formData.append(target.name, target.value);

                // If the button has a formaction attribute, we need to override the formData action with that value
                if (target.hasAttribute('formaction')) {
                    formData.set('action', target.getAttribute('formaction'));
                }

                if (config.method == 'POST') {
                    config.data = formData;
                } else {
                    let params = new URLSearchParams(formData);
                    action += '?' + params.toString();
                }

                Dialog.load(action, config);
            }
        );

        Events.delegate(
            document,
            'click',
            'a[data-dialog],button[data-dialog]',
            (e) => {
                e.preventDefault();

                let target = e.closest;
                let self = this;
                let configBuilder = new ConfigBuilder(target);
                configBuilder.callback = function(callbackEvent) {
                    self.onOpen(this, e, callbackEvent);
                };

                if (target.hasAttribute('data-target')) {
                    Dialog.render(target.getAttribute('data-target'), configBuilder.config);
                } else if (target.hasAttribute('href') && target.getAttribute('href') != '#') {
                    Dialog.load(target.getAttribute('href'), configBuilder.config);
                }
            }
        );

        Events.delegate(document, 'submit', 'form[data-dialog]', (e) => {
            e.preventDefault();

            let self = this;
            let target = e.closest;
            let configBuilder = new ConfigBuilder(target);
            configBuilder.callback = function(callbackEvent) {
                self.onOpen(this, e, callbackEvent);
            };

            let config = configBuilder.config;
            let action = target.getAttribute('action');

            let formData = new FormData(target);

            // FormData does not include the value from the submit button by default
            if (e.submitter) {
                formData.append(e.submitter.name, e.submitter.value);
            }

            if (config.method == 'POST') {
                config.data = formData;
            } else {
                let params = new URLSearchParams(formData);
                action += '?' + params.toString();
            }

            Dialog.load(action, config);
        });
    }

    onOpen(overlay, originalEvent, callbackEvent)
    {
        overlay.target.querySelectorAll('form[data-reset]').forEach(form => form.reset())

        var event = new CustomEvent(Events.OPEN, {
            bubbles: true,
            detail: {
                originalEvent: originalEvent,
                callbackEvent: callbackEvent,
                overlay: overlay
            }
        });

        this.dispatchEvent(event);
    }
}
